/** 한국어. 키 구조는 en.js를 따른다. */
const ko = {
    nav: {
        home: '리사이즈',
        howItWorks: '작동 원리',
        credits: '만든 사람들',
        paper: '논문',
        language: '언어',
        stats: '통계',
    },

    tutorial: {
        badge: '첫 방문',
        title: '처음 오셨군요',
        body:
            'PixelZoom은 일반 이미지 리사이저가 아닙니다. 픽셀 아트가 놓여 있는 블록 격자를 탐지해 도트 ' +
            '하나하나가 정확히 정사각형으로 남도록 확대·축소합니다. 어떤 이미지에서 이게 되는지, 왜 가끔 ' +
            '안 되는지 먼저 보고 오시기를 권합니다.',
        cta: '작동 원리 보기',
        dismiss: '아뇨, 괜찮아요',
    },

    main: {
        tagline: '소수점 배율에서도 도트 격자를 무너뜨리지 않는 픽셀 아트 리사이징.',
        upload: {
            title: '픽셀 아트를 여기에 놓으세요',
            or: '또는 클릭해서 파일 선택',
            hint: 'PNG · GIF · JPG · 최대 5MB',
            dropNow: '놓으면 업로드됩니다',
        },
        loading: '블록 구조를 분석하는 중',
        error: {
            title: '이미지를 분석하지 못했습니다',
            retry: '다른 이미지로 시도',
            unreadable: '이미지로 읽을 수 없는 파일입니다. PNG, GIF, JPG를 사용해 주세요.',
            tooLarge: '이미지가 너무 큽니다. 상한은 5MB, 1600만 화소입니다.',
            network: '서버에 연결하지 못했습니다. 연결 상태를 확인하고 다시 시도해 주세요.',
            server: '서버가 이미지를 처리하지 못했습니다 (HTTP {status}).',
        },
        lossless: {
            title: '블록 크기 {chunk} (무손실)',
            body: '최소 단위 이미지 {width}×{height}를 기준으로 확대·축소하므로 모든 도트가 정사각형으로 남습니다.',
        },
        cropOffer: {
            caption: '테두리 안쪽만 남습니다',
            losslessTitle: '여백이 블록 구조를 가리고 있습니다',
            losslessBody:
                '배경을 잘라내면 블록 크기 {chunk}가 드러나 무손실 리사이징이 가능해집니다. ' +
                '이미지는 {width}×{height}로 잘립니다.',
            lossyTitle: '블록 구조를 찾지 못했습니다',
            lossyBody:
                '배경을 잘라내도 무손실 리사이징은 불가능합니다. 다만 빈 여백은 제거할 수 있습니다 ' +
                '({fromWidth}×{fromHeight} → {toWidth}×{toHeight}). 확대는 정수 배율 최근접 이웃으로 처리됩니다.',
            acceptLossless: '배경 잘라내고 무손실로',
            acceptTrim: '여백만 잘라내기',
            decline: '원본 크기 유지',
        },
        cropped: {
            losslessTitle: '배경 제거 · 블록 크기 {chunk} (무손실)',
            losslessBody: '잘라낸 {width}×{height} 영역을 기준으로 확대·축소합니다.',
            lossyTitle: '배경 제거 · 블록 구조 없음',
            lossyBody:
                '잘라낸 {width}×{height} 영역을 정수 배율 최근접 이웃으로만 확대합니다. 무손실이 아닙니다.',
        },
        nearest: {
            title: '블록 구조를 찾지 못했습니다',
            body: '정수 배율 최근접 이웃 확대만 가능하며 무손실이 보장되지 않습니다. 축소는 제공하지 않습니다.',
            why: '왜 이런가요?',
        },
        controls: {
            scale: '배율',
            resolution: '결과 {width} × {height}',
            adjusted: '{scale}×로 보정됨',
            adjustedHint:
                '도트 하나당 픽셀 수가 정수가 되도록 배율을 스냅했습니다. 이 스냅 덕분에 결과가 무손실로 유지됩니다.',
            mode: {
                slider: '슬라이더',
                custom: '배율 직접 입력',
            },
            customLabel: '배율',
            losslessHint:
                '어떤 배율이든 됩니다. 도트당 픽셀 수가 정수가 되도록 스냅되고 이 스냅 덕분에 결과가 ' +
                '무손실로 유지됩니다. 그래서 적용 배율이 입력한 값과 조금 다를 수 있습니다.',
            lossyHint:
                '블록 구조를 찾지 못해 무손실은 불가능합니다. 입력한 배율 그대로 리사이즈되며 도트 격자가 ' +
                '들쭉날쭉해집니다.',
            applied: '적용 배율 {scale}×',
            limit: '이 이미지는 최대 {max}×까지 가능합니다. 그 이상은 브라우저가 결과를 그리지 못합니다.',
            invalid: '0보다 큰 수를 입력해 주세요.',
        },
        actions: {
            another: '다른 이미지 올리기',
            download: 'PNG 내려받기',
        },
        preview: {
            zoom: '실제 배율',
            fit: '프레임에 맞추기',
            note: '실제 배율에서는 미리보기가 배율에 따라 커지고 작아지며 프레임 밖은 잘려 보입니다.',
        },
    },

    how: {
        title: '작동 원리',
        lead:
            'PixelZoom은 픽셀 아트를 독립된 픽셀의 비트맵이 아니라 본래 모습대로, 누군가 확대해 놓은 작은 ' +
            '도트 격자로 다룹니다. 아래 내용은 모두 이 발상 하나에서 따라 나옵니다.',

        problem: {
            heading: '픽셀 아트 리사이징의 문제',
            body:
                '쌍선형·쌍삼차 보간법은 픽셀 아트를 정의하는 뚜렷한 경계를 뭉개므로, 보통은 최근접 이웃을 ' +
                '씁니다. 그러나 최근접 이웃만으로는 부족합니다. 소수점 배율에서는 도트마다 따로 ' +
                '반올림해야 해서 어떤 도트는 이웃보다 1픽셀 넓게 나오고 격자의 균일함이 깨집니다. 이것을 ' +
                '픽셀 워블 또는 쉬머링이라 부릅니다.',
            sourceNote:
                '왼쪽이 원본이고 두 결과가 거기서 갈라져 나옵니다. 셋 다 같은 배율로 그렸으므로 아래에서 ' +
                '보이는 크기 차이가 곧 실제 크기 차이입니다. 블록은 일부러 작게 잡았습니다. 작을수록 ' +
                '훼손이 뚜렷하게 드러나기 때문입니다.',
            sourceLabel: '원본 · {sourceWidth}×{sourceHeight}',
            sourceCaption: '{chunk}×{chunk} 블록으로 이루어져 있습니다. 도트 하나가 정확히 {chunk}픽셀입니다.',
            naiveLabel: '단순 최근접 이웃 {scale}배 · {naiveWidth}×{naiveHeight}',
            cleanLabel: 'PixelZoom {scale}배 · {cleanWidth}×{cleanHeight}',
            naiveCaption:
                '도트 폭: {widths} px. 한 칸 건너 한 칸이 이웃보다 1.5배 넓습니다. 두 눈의 크기와 좌우 ' +
                '외곽선의 두께를 보세요.',
            cleanCaption: '도트 폭: {widths} px. 어디서나 동일합니다.',
            rulerNote:
                '각 이미지 위의 띠는 한 도트가 끝나고 다음 도트가 시작되는 지점을 표시합니다. 색이 번갈아 바뀌어 ' +
                '폭을 눈으로 셀 수 있습니다.',
            snapNote:
                'PixelZoom은 정확히 {scale}배로 확대하지 않습니다. 도트당 픽셀 수를 정수 {chunkOut}로 ' +
                '반올림하므로 결과는 {effective}배가 됩니다. 요청한 숫자를 그대로 지키지 않는 것이 바로 ' +
                '격자를 온전히 남기는 대가입니다. 계산은 3단계에서 설명합니다.',
        },

        block: {
            heading: '1단계 · 고유 블록 크기 찾기',
            body:
                '정수배로만 확대되어 온 픽셀 아트는 크기가 똑같은 정사각형 블록으로 이루어져 있습니다. 그 ' +
                '크기를 n이라 합시다. PixelZoom은 이미지 가로·세로의 공약수 중에서 큰 것부터 n을 ' +
                '찾습니다.',
            testTitle: '후보 n마다 거치는 검사',
            testBody:
                '이미지를 n으로 축소했다가 최근접 이웃으로 곧장 되돌린 뒤 원본과 비교합니다. 한 픽셀도 ' +
                '다르지 않다면 모든 n×n 블록이 실제로 단색이었다는 뜻이고 n이 블록 크기입니다. 논문은 이 ' +
                '검사를 통과하는 이미지를 온전한 픽셀 아트라 부릅니다.',
            figureCaption:
                '탐지된 블록 크기: {chunk}. 격자가 블록 경계를 표시합니다. 밝게 강조한 한 칸이 도트 하나, ' +
                '즉 단색 {chunk}×{chunk} 픽셀입니다.',
        },

        unit: {
            heading: '2단계 · 최소 단위 이미지로 줄이기',
            body:
                '작품을 블록 크기로 나누면 최소 단위 이미지가 나옵니다. 시각적 도트 하나가 실제 픽셀 ' +
                '하나에 정확히 대응하는 형태입니다. 줄이는 과정에서 잃는 것은 없습니다. 애초에 모든 ' +
                '블록이 단색이었기 때문입니다. 이것은 확대를 걷어낸 작품의 원형 데이터입니다.',
            figureCaption:
                '오른쪽의 {unitWidth}×{unitHeight} 이미지가 왼쪽 {artWidth}×{artHeight} 작품의 내용 전부를 ' +
                '담고 있습니다. 버려진 것은 없습니다.',
            scaleNote:
                '둘 다 같은 {displayZoom}배로 그렸으므로 여기 보이는 크기 차이는 실제 차이입니다. ' +
                '가로세로 각각 {chunk}배 작습니다.',
            sizeNote: '{artWidth}×{artHeight} ÷ {chunk} = {unitWidth}×{unitHeight}',
        },

        scale: {
            heading: '3단계 · 도트 단위로만 확대하기',
            body:
                '여기까지 오면 리사이징은 간단합니다. PixelZoom은 작품을 확대하는 대신 최소 단위 이미지에 ' +
                '도트당 픽셀 수(정수)를 곱합니다. 사용자가 요청한 배율은 가장 가까운 정수를 고르는 데 ' +
                '쓰이므로, 결과는 언제나 도트 격자의 정확한 배수로 떨어집니다.',
            formula: '결과 = 최소 단위 × round(n × 요청 배율)',
            exampleTitle: '실제 계산',
            exampleBody:
                '위 작품은 블록 크기 {chunk}, 최소 단위 {unitWidth}×{unitHeight}입니다. {scale}배를 ' +
                '요청하면 round({chunk} × {scale}) = 도트당 {chunkOut}픽셀이 되어 ' +
                '{outWidth}×{outHeight}가 나옵니다. 모든 도트가 예외 없이 {chunkOut}픽셀 정사각형이며 ' +
                '반올림 오차가 누적되지 않습니다.',
            sliderNote:
                '배율 슬라이더가 연속이 아니라 1/n 간격으로 움직이는 것도 이 때문입니다. 슬라이더가 닿을 ' +
                '수 있는 위치는 모두 격자 위에 남는 배율입니다.',
        },

        client: {
            heading: '연산이 일어나는 곳',
            body:
                '서버는 이미지를 들여다보고 찾아낸 것, 곧 블록 크기와 내용물의 위치만 알려 줍니다. 실제 ' +
                '확대는 여러분의 브라우저에서 캔버스로 이뤄집니다. 두 경로가 비트 단위로 동일한 결과를 ' +
                '낸다는 것을 수치로 확인했으므로 로컬에서 처리해도 잃는 것이 없고 이미지가 네트워크를 ' +
                '거슬러 되돌아올 일도 없습니다.',
        },

        fallback: {
            heading: '탐지에 실패했을 때',
            body:
                '모든 이미지가 온전한 픽셀 아트인 것은 아닙니다. PixelZoom은 그렇지 않은 이미지를 그런 척 ' +
                '넘기지 않고, 그렇지 않다고 알려 드립니다. 결과는 순서대로 세 가지입니다:',
            step1Title: '원본 그대로 탐지',
            step1Body: '손대지 않은 이미지에서 블록 크기를 찾았습니다. 무손실 리사이징이며 아무것도 변형하지 않습니다.',
            step2Title: '잘라내기 제안',
            step2Body:
                '여백은 도트 격자에 정렬되어 있지 않으므로 탐지를 방해할 수 있습니다. 제거할 여백이 ' +
                '있다면 무엇이 잘려 나가는지 먼저 보여 드리고 여쭤봅니다. 그 결과가 무손실이 되든 안 되든 ' +
                '마찬가지입니다.',
            step3Title: '최근접 이웃 폴백',
            step3Body:
                '블록 크기가 존재하지 않으면 정수 배율 최근접 이웃 확대를 제공하며 무손실이 아님을 분명히 ' +
                '표시합니다.',
            wobbleNote:
                '탐지가 실패하는 가장 흔한 이유는 그 이미지가 여러분에게 오기 전에 이미 소수점 배율로 ' +
                '리사이즈된 적이 있기 때문입니다. 도트 폭이 한번 섞이고 나면 되찾을 격자가 남아 있지 ' +
                '않습니다. 정보가 숨겨진 것이 아니라 사라진 것입니다.',
        },

        paper: {
            heading: '엄밀한 정의',
            body:
                '픽셀 아트와 온전한 픽셀 아트의 수학적 정의, 최소 단위 탐지의 상세 의사코드, 그리고 ' +
                '평가지표(색상 손실률, 블록 크기 일관성, 가역성)는 Applied Sciences에 게재된 논문에 실려 ' +
                '있습니다.',
            cta: '논문 읽기',
            repoCta: 'GitHub의 코어 알고리즘',
        },

        tryIt: '내 이미지로 해보기',
    },

    stats: {
        title: '통계 및 분석',
        lead:
            '서버에 도착한 이미지는 수를 세고 그 밖의 것은 남기지 않습니다. 서비스 개시 이래 누적한 수치입니다.',
        usersLabel: '사용한 사람',
        usersNote: '이미지를 한 번이라도 올린 브라우저 수',
        imagesLabel: '분석한 이미지',
        breakdownHeading: '어떤 이미지들이었나',
        lossless: '그대로 처리 가능',
        losslessNote: '손대지 않은 이미지에서 블록 크기를 찾았습니다. 무손실 리사이징입니다.',
        croppable: '배경을 자르면 무손실',
        croppableNote: '여백이 격자를 가리고 있었습니다. 배경을 잘라내면 드러납니다.',
        unsupported: '온전한 픽셀 아트가 아님',
        unsupportedNote:
            '블록 크기가 존재하지 않습니다. 대개 도착하기 전에 이미 소수점 배율로 리사이즈된 이미지입니다.',
        empty: '아직 처리한 이미지가 없습니다.',
        methodHeading: '무엇을 어떻게 세나',
        methodBody:
            '브라우저는 처음 올릴 때 한 번만 세어집니다. 식별자는 없습니다. 브라우저가 "이번이 ' +
            '처음"이라고 알려 주고 서버는 그 한 비트만 받습니다. 그래서 저장소를 비우거나 다른 기기로 ' +
            '오면 다시 세어집니다. 사람 수라기보다 하한선으로 읽어 주세요.',
        storedHeading: '무엇을 남기지 않나',
        storedBody:
            '이미지도, 파일명도, 주소도, 식별자도 남기지 않습니다. 기록은 정수 한 줄입니다. 이미지 몇 장, ' +
            '첫 업로드 몇 번, 그리고 위 세 갈래에 각각 몇 장.',
        unavailable: '기록을 불러오지 못했습니다.',
    },

    credits: {
        title: '만든 사람들',
        lead:
            'PixelZoom은 학부 HCI 팀 설계 과제에서 출발해 게재된 알고리즘이 되었고 이 서비스로 ' +
            '이어졌습니다. 그 과정을 함께한 사람들입니다.',
        roles: {
            web: '웹 서비스 · 개발 및 배포',
            prototype: '프로토타입',
            frontend: '프론트엔드',
            backend: '백엔드',
            infra: '인프라 아키텍처 · 설계 자문',
        },
        names: {
            seo: '서준원',
            leeJH: '이종혁',
            leeJW: '이준원',
            kim: '김준범',
            jungYS: '정윤섭',
            jungJW: '정진우',
        },
        and: '그리고…',
        professorTitle: '{name} 교수님',
        professorNote:
            '이 연구가 가능하도록 연구비를 확보해 주시고 프로젝트에 지원을 아끼지 않으셨습니다.',
        labTitle: 'HRILab',
        labNote: '그리고 그곳에서 함께한 연구실 동료들.',
        paperNote:
            '알고리즘은 「Structure-Aware Pixel Art Scaling via Block Size Detection」' +
            '(Applied Sciences 16(5), 2026)으로 게재되었습니다.',
    },

    support: {
        aria: 'Buy Me a Coffee에서 개발자 후원하기 (새 탭에서 열림)',
    },

    footer: {
        processed: 'PixelZoom은 서비스 개시 이래 {count}개의 픽셀 아트 이미지를 처리했습니다.',
        privacy:
            'PixelZoom은 개인정보를 수집하지 않습니다. 계정도, 쿠키도, 분석 도구도 없습니다. 올린 ' +
            '이미지는 메모리에서 분석되고 저장되지 않으며 리사이징 자체는 여러분의 브라우저에서 ' +
            '이뤄집니다. 언어 선택도 브라우저 안에만 남습니다. 남는 것은 통상적인 서버 접속 로그뿐입니다. ' +
            '다만 이미지를 몇 장 처리했고 몇 개의 브라우저가 올린 적이 있는지, 그 집계 숫자는 남깁니다. ' +
            '정수일 뿐 누구에게도 묶여 있지 않습니다.',
        paper: '논문 (Applied Sciences)',
        coreRepo: '코어 알고리즘',
        tagline: '무손실 픽셀 아트 리사이징',
    },
};

export default ko;
